module.exports = __webpack_public_path__ + "static/media/hot_zgzqy.d4ecf527.png";